export default __webpack_public_path__ + "static/media/icon-interno.ed0cc1ab.svg";